module.exports = __webpack_public_path__ + "img/alpha.35b29c1e.png";